<template>
  <main>
    <b-container v-if="currentUser">
      <div class="page-breadcrumb">
        <router-link :to="{ name: 'UserView' }">
          <i class="fa fa-angle-left" /> Back to user details
        </router-link>
      </div>

      <div class="section-header">
        <h1 class="m-0">
          Edit user details 
          <!-- {{ currentUser.full_name }} -->
        </h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <UserForm
              :form="form"
              :show-password="false"
              @callback="submit"
            ></UserForm>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import Vue from "vue";
import { setTimeout } from "timers";
import { mapActions, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import UserForm from "./UserForm";

export default {
  name: "UserEdit",
  components: {
    UserForm,
  },
  extends: InitAdmin,
  data() {
    return {
      currentUser: null,
      form: {
        id: null,
        username: null,
        email: null,
        firstName: null,
        lastName: null,
        createdTimestamp: null
      },
    };
  },
  computed: {
    ...mapState({
      users: (state) => state.user.users,
    }),
  },
  mounted() {
    this.currentUser = _.find(
      this.users, (user) => this.$route.params.id === user._id
    );
    this.form.id = this.currentUser._id;
    this.form.username = this.currentUser.user_name;
    this.form.email = this.currentUser.email;
    this.form.firstName = this.currentUser.first_Name;
    this.form.lastName = this.currentUser.last_Name;
    this.form.createdTimestamp = this.currentUser.createdTs;
  },
  methods: {
    ...mapActions(["loadUser", "updateUser", "saveAuthenticatedUserInfo"]),
    submit() {
      this.updateUser(this.form).then((res) => {
        if(res.status === 204){
          this.saveAuthenticatedUserInfo(
            {
              id: this.form.id,
              role: "user",
              name: this.form.username,
              fullname: this.form.firstName + " " + this.form.lastName
            }
          );
        }
        this.$toasted.show("User saved", { type: "success" });
        setTimeout(() => {
          this.$router.push({
            name: "UserView",
            params: { id: this.currentUser._id },
          });
        }, 1000);
      });
    },
  },
};
</script>
